export const generateURLOptions = (type = null) => {
  const userToken = localStorage.getItem("accessToken") ?? "";

  return {
    "Content-Type": type ?? "application/json",
    authorization: userToken,
  };
};
